import FormatorImageModelCommon from 'common/models/formator-image';

export default class FormatorImageModel extends FormatorImageModelCommon {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'formator-image': FormatorImageModel;
  }
}
